import React, { Component } from "react";
import { Link } from "react-router-dom";
//import { CSVLink } from 'react-csv';
import { getCardTrades } from "../services/cardTradeService";
import { getBitcoinsTrades } from "../services/bitcoinsTradeService";
import { getCardTypes } from "../services/cardTypeService";
import { getCardCurrencies } from "../services/cardCurrencyService";
import { getCardRanges } from "../services/cardRangeService";
import { getCardReceipts } from "../services/cardReceiptService";
import { getUsers } from "../services/userService";
import { getDailyUserSignup } from "../services/userService";
//import { BASE_URL } from '../constant';
import { truncate } from "../utils/functions";
import Card from "./common/card";
import moment from "moment";
// import socketIOClient from 'socket.io-client';
import Chart from "chart.js";
import axios from "axios";
import { data } from "jquery";

class DashBoard extends Component {
  state = {
    data: "",
    // gtrades: [],
    // btrades: [],
    // ctypes: [],
    // ccurrencies: [],
    // cranges: [],
    // creceipts: [],
    // users: [],
    // loading: false,
    // userCount: 0,
    // gtradeCount: 0,
    // btradeCount: 0,
    //endpoint: 'http://127.0.0.1:3900'
    //endpoint: 'https://jeriod-api.herokuapp.com',
  };

  chartRef = React.createRef();

  async componentDidMount() {
    //const { endpoint } = this.state;
    //const socket = socketIOClient(endpoint);

    this.setState({ loading: true });
    // const dailyRegisteredUsers = await getDailyUserSignup();
    // //const metrics_response = await getMetrics();
    // const gtrades_response = await getCardTrades();
    // const btrades_response = await getBitcoinsTrades();
    // const users_response = await getUsers();
    // const ctypes_response = await getCardTypes();
    // const ccurrencies_response = await getCardCurrencies();
    // const cranges_response = await getCardRanges();
    // const creceipts_response = await getCardReceipts();
    // this.setState({ loading: false });

    // const { data: gtrades } = gtrades_response.data;
    // const { data: btrades } = btrades_response.data;
    // const { data: users } = users_response.data;
    // const { data: ctypes } = ctypes_response.data;
    // const { data: ccurrencies } = ccurrencies_response.data;
    // const { data: cranges } = cranges_response.data;
    // const { data: creceipts } = creceipts_response.data;

    // const { length: userCount } = users;
    // const { length: gtradeCount } = gtrades;
    // const { length: btradeCount } = btrades;

    // socket.on('FromUSER', (data) => {
    //   this.setState({ userCount: data });
    // });

    // socket.on('FromGCTrade', (data) => {
    //   this.setState({ gtradeCount: data });
    // });

    // socket.on('FromBTrade', (data) => {
    //   this.setState({ btradeCount: data });
    // });

    // let dateData = [];
    // let userCountData = [];
    // for (let dailySignup of dailyRegisteredUsers.data) {
    //   dateData = dateData.concat(dailySignup.date);
    //   userCountData = userCountData.concat(dailySignup.usersCount);
    // }
    axios.get("/admins/analytics").then((resp) => {
      this.setState({
        data: resp.data.data,
        loading: false,
      });
    });

    // Chart.defaults.global.defaultFontFamily = 'circular-book';
    // Chart.defaults.global.defaultFontColor = '#858796';

    // Area Chart Example
    // var ctx = document.getElementById('myAreaChart');
    // var myLineChart = new Chart(ctx, {
    //   type: 'line',
    //   data: {
    //     labels: dateData,
    //     datasets: [
    //       {
    //         label: 'User Signup',
    //         lineTension: 0.3,
    //         backgroundColor: 'rgba(27, 94, 32, 0.05)',
    //         borderColor: 'rgba(27, 94, 32, 1)',
    //         pointRadius: 3,
    //         pointBackgroundColor: 'rgba(27, 94, 32, 1)',
    //         pointBorderColor: 'rgba(27, 94, 32, 1)',
    //         pointHoverRadius: 3,
    //         pointHoverBackgroundColor: 'rgba(27, 94, 32, 1)',
    //         pointHoverBorderColor: 'rgba(27, 94, 32, 1)',
    //         pointHitRadius: 10,
    //         pointBorderWidth: 2,
    //         data: userCountData,
    //       },
    //     ],
    //   },
    //   options: {
    //     maintainAspectRatio: false,
    //     layout: {
    //       padding: {
    //         left: 0,
    //         right: 0,
    //         top: 0,
    //         bottom: 0,
    //       },
    //     },
    //     scales: {
    //       xAxes: [
    //         {
    //           time: {
    //             unit: 'date',
    //           },
    //           gridLines: {
    //             display: false,
    //             drawBorder: false,
    //           },
    //           ticks: {
    //             maxTicksLimit: 7,
    //           },
    //         },
    //       ],
    //       yAxes: [
    //         {
    //           ticks: {
    //             maxTicksLimit: 7,
    //             padding: 10,
    //             // Include a dollar sign in the ticks
    //             callback: function (value, index, values) {
    //               return number_format(value);
    //             },
    //           },
    //           gridLines: {
    //             color: 'rgb(234, 236, 244)',
    //             zeroLineColor: 'rgb(234, 236, 244)',
    //             drawBorder: false,
    //             borderDash: [2],
    //             zeroLineBorderDash: [2],
    //           },
    //         },
    //       ],
    //     },
    //     legend: {
    //       display: false,
    //     },
    //     tooltips: {
    //       backgroundColor: 'rgb(255,255,255)',
    //       bodyFontColor: '#858796',
    //       titleMarginBottom: 10,
    //       titleFontColor: '#6e707e',
    //       titleFontSize: 14,
    //       borderColor: '#dddfeb',
    //       borderWidth: 1,
    //       xPadding: 15,
    //       yPadding: 15,
    //       displayColors: false,
    //       intersect: false,
    //       mode: 'index',
    //       caretPadding: 10,
    //       callbacks: {
    //         label: function (tooltipItem, chart) {
    //           var datasetLabel =
    //             chart.datasets[tooltipItem.datasetIndex].label || '';
    //           return datasetLabel + ': ' + number_format(tooltipItem.yLabel);
    //         },
    //       },
    //     },
    //   },
    // });

    // socket.on('UserSignupCount', (data) => {
    //   let realTimeDateData = [];
    //   let realTimeUserCountData = [];
    //   for (let ds of data) {
    //     realTimeDateData = realTimeDateData.concat(ds.date);
    //     realTimeUserCountData = realTimeUserCountData.concat(ds.usersCount);
    //   }
    //   myLineChart.data.datasets[0].data = realTimeUserCountData;
    //   myLineChart.data.datasets[0].labels = realTimeDateData;
    //   myLineChart.update({
    //     duration: 2000,
    //     easing: 'easeOutBounce',
    //   });
    //   //console.log(data);
    //   //console.log(d);
    // });
  }

  //   getPagedData = () => {
  //     const {
  //       //metric,
  //       gtrades,
  //       btrades,
  //       users,
  //       ctypes,
  //       ccurrencies,
  //       cranges,
  //       creceipts,
  //       signupDates,
  //       signupCounts,
  //       userCount,
  //       gtradeCount,
  //       btradeCount,
  //     } = this.state;

  //     return {
  //       gtrades,
  //       btrades,
  //       users,
  //       ctypes,
  //       ccurrencies,
  //       cranges,
  //       creceipts,
  //       signupDates,
  //       signupCounts,
  //       userCount,
  //       gtradeCount,
  //       btradeCount,
  //     };
  //   };

  render() {
    // const {
    //   gtrades,
    //   btrades,
    //   //ctypes,
    //   //ccurrencies,
    //   //cranges,
    //   //creceipts,
    //   users,
    //   userCount,
    //   gtradeCount,
    //   btradeCount,
    // } = this.state
    const users = this.state.data.users;
    const user_balance = this.state.data.user_balance;
    const btrades = this.state.data.btrades;
    const gtrades = this.state.data.gtrades;
    return (
      <React.Fragment>
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Dashboard</h1>

          {/* <CSVLink
            className="d-none d-sm-inline-block btn btn-sm btn-invest shadow-sm"
            data={this.state.users}
          >
            <i className="fas fa-download fa-sm text-white-50" /> Download Users
          </CSVLink> */}
        </div>
        <div className="row">
          <Card
            textColor="text-primary"
            bcolor="border-left-primary"
            faIcon="fa-users"
            title="Users"
            value={users}
          />
          <Card
            textColor="text-primary"
            bcolor="border-left-warning"
            faIcon="fa-money-bill-wave"
            title="Total User Balance"
            value={user_balance}
          />

          <Card
            textColor="text-success"
            bcolor="border-left-success"
            faIcon="fa-tasks"
            title="Card Trades"
            value={gtrades}
          />

          <Card
            textColor="text-danger"
            bcolor="border-left-danger"
            faIcon="fa-tasks"
            title="Bitcoins Trade"
            value={btrades}
          />

          {/* <Card
            textColor="text-info"
            bcolor="border-left-info"
            faIcon="fa-bell"
            title="Announcements"
            value={userCount}
          /> */}
        </div>
        {/* <div className="row row-sm mg-t-15 mg-sm-t-20">
          {users.length > 0 ? (
            <div className="col-sm-6 col-xl-4 mg-t-15 mg-sm-t-20 order-md-3 order-lg-0 mb-4">
              <div className="card card-hover card-transactions">
                <div className="card-header bg-transparent">
                  <h6 className="card-title mg-b-0">Recent Users</h6>
                </div>
                <ul className="list-group list-group-flush">
                  {users
                    .reverse()
                    .slice(0, 5)
                    .map((user) => (
                      <li key={user._id} className="list-group-item">
                        <div className="d-sm-flex align-items-center justify-content-between mb-1 mt-2">
                          <h6
                            className="ml-2"
                            style={{
                              fontSize: 13 + "px",
                              fontWeight: "bold",
                              color: "#000524",
                            }}
                          >
                            {truncate(user.name)}
                          </h6> */}
        {/* <img
                          className="rounded-circle"
                          style={{
                            backgroundColor: 'white',
                            padding: 5 + 'px',
                          }}
                          src={`${BASE_URL}/${user.image && user.image.path}`}
                          width="40px"
                          height="40px"
                          alt=""
                        /> */}
        {/* </div>
                        <div className="d-sm-flex align-items-center justify-content-between mb-2">
                          <small
                            className="ml-2"
                            style={{ fontSize: 11 + "px" }}
                          >
                            joined on{" "}
                            {moment(user.signupDate)
                              .startOf("day")
                              .format("MMM DD, YYYY")}
                          </small>
                          <small
                            className="mr-2"
                            style={{ fontSize: 11 + "px" }}
                          ></small>
                        </div>
                      </li>
                    ))}
                </ul> */}
        {/* <div className="card-footer bg-transparent">
                  <Link
                    className="btn btn-sm btn-invest"
                    style={{ marginTop: 0 }}
                    to="/users"
                  >
                    View All Users
                  </Link>
                </div>
              </div>
            </div>
          ) : ( */}
        {/* <div className="col-sm-6 col-xl-4 mg-t-15 mg-sm-t-20 order-md-3 order-lg-0">
              <div className="card card-hover card-transactions">
                <div className="card-header bg-transparent">
                  <h6 className="card-title mg-b-0">You've got no users</h6>
                </div>
              </div>
            </div>
          )} */}
        {/* {gtrades.length > 0 ? (
            <div className="col-sm-6 col-xl-4 mg-t-15 mg-sm-t-20 order-md-3 order-lg-0 mb-4">
              <div className="card card-hover card-transactions">
                <div className="card-header bg-transparent">
                  <h6 className="card-title mg-b-0">Latest Card Trades</h6>
                </div>
                <ul className="list-group list-group-flush">
                  {gtrades
                    .reverse()
                    .slice(0, 5)
                    .map((gtrade) => (
                      <li key={gtrade._id} className="list-group-item">
                        <div className="d-sm-flex align-items-center justify-content-between mb-1 mt-2">
                          <h6
                            className="ml-2"
                            style={{
                              fontSize: 13 + "px",
                              fontWeight: "bold",
                              color: "#000524",
                            }}
                          >
                            {gtrade.trade_reference}
                          </h6>
                        </div>
                        <div className="d-sm-flex align-items-center justify-content-between mb-2">
                          <small
                            className="ml-2"
                            style={{ fontSize: 11 + "px" }}
                          >
                            by {gtrade.user}
                          </small>
                          <small
                            className="mr-2"
                            style={{ fontSize: 11 + "px" }}
                          >
                            {`${gtrade.cardCountry}(${gtrade.card_value})`}
                          </small>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          ) : ( */}
        {/* <div className="col-sm-6 col-xl-3 mg-t-15 mg-sm-t-20 order-md-3 order-lg-0">
              <div className="card card-hover card-transactions">
                <div className="card-header bg-transparent">
                  <h6 className="card-title mg-b-0">
                    No card trade @ the moment!
                  </h6>
                </div>
              </div>
            </div>
          )} */}
        {/* 
          {btrades.length > 0 ? (
            <div className="col-sm-6 col-xl-4 mg-t-15 mg-sm-t-20 order-md-3 order-lg-0 mb-4">
              <div className="card card-hover card-transactions">
                <div className="card-header bg-transparent">
                  <h6 className="card-title mg-b-0">Latest Bitcoins Trades</h6>
                </div>
                <ul className="list-group list-group-flush">
                  {btrades
                    .reverse()
                    .slice(0, 5)
                    .map((btrade) => (
                      <li key={btrade._id} className="list-group-item">
                        <div className="d-sm-flex align-items-center justify-content-between mb-1 mt-2">
                          <h6
                            className="ml-2"
                            style={{
                              fontSize: 13 + "px",
                              fontWeight: "bold",
                              color: "#000524",
                            }}
                          >
                            {btrade.trade_reference}
                          </h6>
                        </div>
                        <div className="d-sm-flex align-items-center justify-content-between mb-2">
                          <small
                            className="ml-2"
                            style={{ fontSize: 11 + "px" }}
                          >
                            by {btrade.user}
                          </small>
                          <small
                            className="mr-2"
                            style={{ fontSize: 11 + "px" }}
                          >
                            {btrade.amount}
                          </small>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          ) : (
            <div className="col-sm-6 col-xl-4 mg-t-15 mg-sm-t-20 order-md-3 order-lg-0">
              <div className="card card-hover card-transactions">
                <div className="card-header bg-transparent">
                  <h6 className="card-title mg-b-0">
                    No bitcoin trade @ the moment!
                  </h6>
                </div>
              </div>
            </div>
          )}
        </div> */}
        {/* <div className="row">
          <div className="col-xl-12 col-lg-10">
            <div className="card shadow mb-4">
              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 className="m-0 font-weight-bold text-custom">
                  Daily User Signup Overview
                </h6>
              </div>
              <div className="card-body">
                <div className="chart-area">
                  <canvas id="myAreaChart" />
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </React.Fragment>
    );
  }
}

export default DashBoard;
